import mitt from 'mitt'

const emitter = mitt()

const EventBus = {
  $on: (...args) => emitter.on(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args)
}

export default EventBus
